(ns practitest.frontend.components2.requirement-testing-status
  (:require [practitest.frontend.common.i18n :refer [get-translation]]))

;; Some hardcoded issues statuses colors as in figma:
;;https://www.figma.com/file/0aTwitb3NTlNHmCpBFb3XA/Practitest-UX-Clients?type=design&node-id=2869-133792&mode=dev

(def statuses-map
  {"PASSED"      {:label (get-translation "requirement-testing-status.passed" "PASSED")
                  :color "var(--pt-color-success)"}
   "FAILED"      {:label (get-translation "requirement-testing-status.failed" "FAILED")
                  :color "var(--pt-color-error)"}
   "BLOCKED"     {:label (get-translation "requirement-testing-status.blocked" "BLOCKED")
                  :color "var(--pt-color-status-blocked)"}
   "STARTED"     {:label (get-translation "requirement-testing-status.started" "STARTED")
                  :color "var(--pt-color-status-started)"}
   "NO RUN"      {:label (get-translation "requirement-testing-status.no-run" "NO RUN")
                  :color "var(--pt-color-status-no-run)"}
   "NOT COVERED" {:label (get-translation "requirement-testing-status.not-covered" "NOT COVERED")
                  :color "var(--pt-color-status-not-covered)"}
   "N/A"         {:label (get-translation "requirement-testing-status.na" "N/A")
                  :color "var(--pt-color-status-na)"}})

(def default-color "var(--pt-color-border-light)")

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        ;; Use label itself here
        status)))

(defn get-status-color
  [status]
  (or (:color (get statuses-map status))
      default-color))

(defn requirement-status-component
  [status]
  [:<>
   [:span.status-indicator
    {:style {:color (get-status-color status)}}]
   (get-status-label status)])
